export default __webpack_public_path__ + "static/media/service-1.023bf8d1.svg";